import { useCallback, useMemo, useState } from 'react'
import { Virtuoso } from 'react-virtuoso'
import { useSubcategories } from '~/entities/categories'
import { useIsFeatureEnabled } from '~/shared/lib/feature-flags'
import { SearchView, Text } from '~/shared/ui'
import { ClassificationItem } from './classification-item'

export function ClassificationFilter() {
  const subcategories = useSubcategories()
  const [searchValue, setSearchValue] = useState('')
  const isHideLlmClassificationEnabled = useIsFeatureEnabled('2026-08-hide-llm-classification')

  const handleSearchChange = useCallback((value: string) => {
    setSearchValue(value)
  }, [])

  const filteredSubcategories = useMemo(() => {
    return subcategories.filter((subcategory) => {
      return subcategory.displayLabel.toLowerCase().includes(searchValue.toLowerCase())
    })
  }, [subcategories, searchValue])

  const visibleSubcategories = useMemo(() => {
    if (searchValue) {
      return filteredSubcategories
    }
    return subcategories
  }, [filteredSubcategories, subcategories, searchValue])

  return (
    <SearchView
      value={searchValue}
      onChange={handleSearchChange}
      placeholder="Search"
      forceOpen
      scrollable={false}
    >
      {isHideLlmClassificationEnabled && (
        <div className="bg-surface-low mx-4 my-2 rounded-sm px-2 py-1">
          <Text
            className="text-text-secondary"
            appearance="CAPTION"
          >
            Prior Auth classifications are shown for finished documents only.
          </Text>
        </div>
      )}
      {visibleSubcategories.length > 0 ? (
        <>
          {visibleSubcategories.length < 5 ? (
            visibleSubcategories.map((subcategory) => (
              <ClassificationItem
                key={subcategory.label}
                subcategory={subcategory}
                searchValue={searchValue}
              />
            ))
          ) : (
            <Virtuoso
              className="min-h-[280px]"
              data={visibleSubcategories}
              itemContent={(_, subcategory) => {
                return (
                  <ClassificationItem
                    key={subcategory.label}
                    subcategory={subcategory}
                    searchValue={searchValue}
                  />
                )
              }}
            />
          )}
        </>
      ) : (
        <Text
          className="box-border w-full px-4 py-3"
          appearance="SUBTITLE"
        >
          No Results
        </Text>
      )}
    </SearchView>
  )
}
